module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (183).f90de8c2.jpg";